module.exports = __webpack_public_path__ + "img/wakipharma.e14d039f.jpg";